import { apiUrls } from "../../utils/app-constants";
import { apiSlice } from "../services/apiSlice";

export const txnApi = apiSlice
  .enhanceEndpoints({
    tagTypes: ["user"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllTxn: builder.query({
        query: (params) => {
          const searchParams = new URLSearchParams(params).toString();
          return {
            url: `/admin/transactions?${searchParams}`,
            method: "GET",
          };
        },
        providesTags: ["user"],
      }),
    }),
  });

export const { useGetAllTxnQuery } = txnApi;
